import { render, staticRenderFns } from "./SingPauseSchulenOGS.vue?vue&type=template&id=4a7153ac&"
import script from "./SingPauseSchulenOGS.vue?vue&type=script&lang=js&"
export * from "./SingPauseSchulenOGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports